"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyHlOnboardingDataTypeId = exports.HlOnboardingDataTypeId = void 0;
const CommonOnboardingDataTypeId_1 = require("../../common/domain/CommonOnboardingDataTypeId");
var HlOnboardingDataTypeId;
(function (HlOnboardingDataTypeId) {
    HlOnboardingDataTypeId["HL_PAYMENT_PLAN"] = "HL_PAYMENT_PLAN";
})(HlOnboardingDataTypeId = exports.HlOnboardingDataTypeId || (exports.HlOnboardingDataTypeId = {}));
exports.AnyHlOnboardingDataTypeId = Object.assign({}, CommonOnboardingDataTypeId_1.CommonOnboardingDataTypeId, HlOnboardingDataTypeId);
//# sourceMappingURL=HlOnboardingDataTypeId.js.map